import { connect } from 'react-redux';
import informationModule from 'app/store/information';
import PriceList from './PriceList.component';
import { requestCinema } from 'app/store/cinemas/actions';

const {
  priceListContentRequest,
  setPriceListContent,
  setPriceListGastronomyContent
} = informationModule.actions;

const mapStateToProps = ({ information }) => (
  {
    content: information.priceListContent
  });

const mapDispatchToProps = {
  fetchContent: priceListContentRequest,
  clearPriceListState: setPriceListContent.bind(null, null),
  clearGastronomyState: setPriceListGastronomyContent.bind(null, null),
  fetchCinema: requestCinema,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PriceList);
